import type { Lang } from '@/i18n/config'
import { useT } from '@/i18n/I18nProvider'

// Tradução de EXIBIÇÃO das categorias do set padrão (Lunch Money) + investimentos.
// Os dados no banco NÃO mudam — só o rótulo mostrado segue o idioma. Categorias
// customizadas (fora deste mapa) aparecem como o usuário digitou.
//
// Chave = texto SEM emoji (como está gravado). Valor = { en, pt-BR, es }.
type Tri = { en: string; 'pt-BR': string; es: string }

const MAP: Record<string, Tri> = {
  // Receitas
  'Refunds Income': { en: 'Refunds', 'pt-BR': 'Reembolsos', es: 'Reembolsos' },
  'Lotery Income': { en: 'Lottery', 'pt-BR': 'Loteria', es: 'Lotería' },
  'Others Income': { en: 'Other Income', 'pt-BR': 'Outras Receitas', es: 'Otros Ingresos' },
  'Salary Income': { en: 'Salary', 'pt-BR': 'Salário', es: 'Salario' },
  'Loans Income': { en: 'Loans Received', 'pt-BR': 'Empréstimos Recebidos', es: 'Préstamos Recibidos' },
  // Despesas — principais
  Travel: { en: 'Travel', 'pt-BR': 'Viagem', es: 'Viajes' },
  'Food and Drinks': { en: 'Food and Drinks', 'pt-BR': 'Alimentação', es: 'Comida y Bebidas' },
  Entertainment: { en: 'Entertainment', 'pt-BR': 'Entretenimento', es: 'Entretenimiento' },
  Housing: { en: 'Housing', 'pt-BR': 'Moradia', es: 'Vivienda' },
  Pets: { en: 'Pets', 'pt-BR': 'Pets', es: 'Mascotas' },
  Family: { en: 'Family', 'pt-BR': 'Família', es: 'Familia' },
  Utilities: { en: 'Utilities', 'pt-BR': 'Utilidades', es: 'Servicios' },
  Financial: { en: 'Financial', 'pt-BR': 'Financeiro', es: 'Financiero' },
  'Personal Care': { en: 'Personal Care', 'pt-BR': 'Cuidados Pessoais', es: 'Cuidado Personal' },
  Transportation: { en: 'Transportation', 'pt-BR': 'Transporte', es: 'Transporte' },
  Shopping: { en: 'Shopping', 'pt-BR': 'Compras', es: 'Compras' },
  // Despesas — subcategorias
  'Coffee Shops': { en: 'Coffee Shops', 'pt-BR': 'Cafeterias', es: 'Cafeterías' },
  Healthcare: { en: 'Healthcare', 'pt-BR': 'Saúde', es: 'Salud' },
  Electricity: { en: 'Electricity', 'pt-BR': 'Eletricidade', es: 'Electricidad' },
  Activities: { en: 'Activities', 'pt-BR': 'Atividades', es: 'Actividades' },
  Gas: { en: 'Gas', 'pt-BR': 'Combustível', es: 'Combustible' },
  'Grooming, Care Services': { en: 'Grooming, Care Services', 'pt-BR': 'Estética e Cuidados', es: 'Estética y Cuidados' },
  Internet: { en: 'Internet', 'pt-BR': 'Internet', es: 'Internet' },
  'Alcohol, Bars': { en: 'Alcohol, Bars', 'pt-BR': 'Bebidas e Bares', es: 'Alcohol y Bares' },
  Restaurants: { en: 'Restaurants', 'pt-BR': 'Restaurantes', es: 'Restaurantes' },
  Toys: { en: 'Toys', 'pt-BR': 'Brinquedos', es: 'Juguetes' },
  Education: { en: 'Education', 'pt-BR': 'Educação', es: 'Educación' },
  Events: { en: 'Events', 'pt-BR': 'Eventos', es: 'Eventos' },
  Gaming: { en: 'Gaming', 'pt-BR': 'Games', es: 'Videojuegos' },
  Lotery: { en: 'Lottery', 'pt-BR': 'Loteria', es: 'Lotería' },
  Fitness: { en: 'Fitness', 'pt-BR': 'Fitness', es: 'Fitness' },
  Experiences: { en: 'Experiences', 'pt-BR': 'Experiências', es: 'Experiencias' },
  'Bank Fees': { en: 'Bank Fees', 'pt-BR': 'Tarifas Bancárias', es: 'Comisiones Bancarias' },
  Loans: { en: 'Loans', 'pt-BR': 'Empréstimos', es: 'Préstamos' },
  'Property Tax': { en: 'Property Tax', 'pt-BR': 'IPTU', es: 'Impuesto Predial' },
  Hotels: { en: 'Hotels', 'pt-BR': 'Hotéis', es: 'Hoteles' },
  'Veterinary Care': { en: 'Veterinary Care', 'pt-BR': 'Veterinário', es: 'Veterinaria' },
  Clothing: { en: 'Clothing', 'pt-BR': 'Roupas', es: 'Ropa' },
  'Beauty, Wellness': { en: 'Beauty, Wellness', 'pt-BR': 'Beleza e Bem-estar', es: 'Belleza y Bienestar' },
  'Gifts and Donations': { en: 'Gifts and Donations', 'pt-BR': 'Presentes e Doações', es: 'Regalos y Donaciones' },
  Condominium: { en: 'Condominium', 'pt-BR': 'Condomínio', es: 'Condominio' },
  'Interest, Fees': { en: 'Interest, Fees', 'pt-BR': 'Juros e Taxas', es: 'Intereses y Comisiones' },
  'Rent, Mortgage': { en: 'Rent, Mortgage', 'pt-BR': 'Aluguel, Financiamento', es: 'Alquiler, Hipoteca' },
  Taxes: { en: 'Taxes', 'pt-BR': 'Impostos', es: 'Impuestos' },
  Electronics: { en: 'Electronics', 'pt-BR': 'Eletrônicos', es: 'Electrónica' },
  Investimentos: { en: 'Investments', 'pt-BR': 'Investimentos', es: 'Inversiones' },
  'Pet insurance': { en: 'Pet Insurance', 'pt-BR': 'Seguro Pet', es: 'Seguro de Mascota' },
  'Auto Insurance': { en: 'Auto Insurance', 'pt-BR': 'Seguro Auto', es: 'Seguro de Auto' },
  'Self-improvement': { en: 'Self-improvement', 'pt-BR': 'Autodesenvolvimento', es: 'Autodesarrollo' },
  'Books, Media': { en: 'Books, Media', 'pt-BR': 'Livros e Mídia', es: 'Libros y Medios' },
  Phone: { en: 'Phone', 'pt-BR': 'Telefone', es: 'Teléfono' },
  'Others Outcome': { en: 'Other Expenses', 'pt-BR': 'Outras Despesas', es: 'Otros Gastos' },
  'Food Delivery': { en: 'Food Delivery', 'pt-BR': 'Delivery', es: 'Delivery' },
  'Streaming Services': { en: 'Streaming Services', 'pt-BR': 'Streaming', es: 'Streaming' },
  'Home GAS': { en: 'Home Gas', 'pt-BR': 'Gás de Cozinha', es: 'Gas del Hogar' },
  'Car Maintenance': { en: 'Car Maintenance', 'pt-BR': 'Manutenção do Carro', es: 'Mantenimiento del Auto' },
  'Food and Supplies': { en: 'Food and Supplies', 'pt-BR': 'Alimentos e Suprimentos', es: 'Alimentos y Suministros' },
  'Professional Services': { en: 'Professional Services', 'pt-BR': 'Serviços Profissionais', es: 'Servicios Profesionales' },
  'Clothing, Essentials': { en: 'Clothing, Essentials', 'pt-BR': 'Roupas e Essenciais', es: 'Ropa y Esenciales' },
  Childcare: { en: 'Childcare', 'pt-BR': 'Cuidado Infantil', es: 'Cuidado Infantil' },
  Children: { en: 'Children', 'pt-BR': 'Filhos', es: 'Hijos' },
  'Home Goods': { en: 'Home Goods', 'pt-BR': 'Utensílios Domésticos', es: 'Artículos del Hogar' },
  'Public Transit': { en: 'Public Transit', 'pt-BR': 'Transporte Público', es: 'Transporte Público' },
  'Rideshare, Taxi': { en: 'Rideshare, Taxi', 'pt-BR': 'Transporte por App, Táxi', es: 'Transporte por App, Taxi' },
  'Car Payment': { en: 'Car Payment', 'pt-BR': 'Prestação do Carro', es: 'Pago del Auto' },
  Groceries: { en: 'Groceries', 'pt-BR': 'Mercado', es: 'Supermercado' },
  'Home Maintenance': { en: 'Home Maintenance', 'pt-BR': 'Manutenção da Casa', es: 'Mantenimiento del Hogar' },
  'Air Transit': { en: 'Air Transit', 'pt-BR': 'Transporte Aéreo', es: 'Transporte Aéreo' },
  Parking: { en: 'Parking', 'pt-BR': 'Estacionamento', es: 'Estacionamiento' },
}

// Separa "🍔 Texto" em [emoji, texto]. Sem emoji → ['', name].
const SPLIT = /^(\p{Extended_Pictographic}(?:️|‍\p{Extended_Pictographic})*)\s*(.*)$/u

// Só o TEXTO traduzido, SEM emoji — para ORDENAR de A a Z pela letra (o emoji no
// começo faria a ordenação sair pelos codepoints do emoji, não pela palavra).
export function categorySortKey(name: string | null | undefined, lang: Lang): string {
  const label = translateCategory(name, lang)
  const m = label.match(SPLIT)
  return (m ? m[2] : label).trim().toLocaleLowerCase()
}

// Rótulo da categoria no idioma atual. Mantém o emoji; só traduz o texto se ele
// estiver no mapa do set padrão. Categoria custom → devolve o nome como está.
export function translateCategory(name: string | null | undefined, lang: Lang): string {
  if (!name) return name ?? ''
  const m = name.match(SPLIT)
  const emoji = m ? m[1] : ''
  const text = (m ? m[2] : name).trim()
  const tri = MAP[text]
  if (!tri) return name
  const translated = tri[lang] ?? tri['pt-BR']
  return emoji ? `${emoji} ${translated}` : translated
}

// Hook: devolve tc(name) que traduz o nome da categoria no idioma atual.
// eslint-disable-next-line react-refresh/only-export-components
export function useTranslateCategory() {
  const { lang } = useT()
  return (name: string | null | undefined) => translateCategory(name, lang)
}

// Hook: chave de ordenação A-Z (texto traduzido, sem emoji) no idioma atual.
// eslint-disable-next-line react-refresh/only-export-components
export function useCategorySortKey() {
  const { lang } = useT()
  return (name: string | null | undefined) => categorySortKey(name, lang)
}
